import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { FsNavModule } from '@firestitch/nav';
import { FsStore } from '@firestitch/store';

import { tap } from 'rxjs/operators';

import { NavService } from '@common/services';

import { SidenavService } from '../../services/sidenav.service';
import { AccountMenuComponent } from '../account-menu';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIconModule,
        MatToolbarModule,
        MatButtonModule,
        NgTemplateOutlet,
        FsNavModule,
        AccountMenuComponent,
    ]
})
export class HeaderComponent implements OnInit {

  public account = signal<unknown>(null);

  /** Markup the open view wants rendered beside the title, if any. */
  public titleTemplate = inject(NavService).titleTemplate;

  private _store = inject(FsStore);
  private _sidenavService = inject(SidenavService);
  private _destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this._store.observe('account')
      .pipe(
        tap((store) => this.account.set(store.value)),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }

  public sideNavClick(): void {
    this._sidenavService.toggle();
  }

}
